import { render, staticRenderFns } from "./PersonnelRecordPane.vue?vue&type=template&id=3b5d62ea&scoped=true"
import script from "./PersonnelRecordPane.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordPane.vue?vue&type=script&lang=js"
import style0 from "./PersonnelRecordPane.vue?vue&type=style&index=0&id=3b5d62ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d62ea",
  null
  
)

export default component.exports